import { apiFetch } from '../helpers/api-fetch';
import { WorkTaskGroup } from '../models/worktaskgroup';

export class WorkTaskGroupService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain

    // Get all work task groups
    public static async getAll() {
        const res = await apiFetch(`${WorkTaskGroupService.APIUrl}/api/worktaskgroups`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get Work task group by id
    public static async getById(id: string) {
        const res = await apiFetch(`${WorkTaskGroupService.APIUrl}/api/worktaskgroups/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // create a new work task group or update its data
    public static createOrUpdate(taskgroup: WorkTaskGroup) {
        
        return apiFetch(`${WorkTaskGroupService.APIUrl}/api/worktaskgroups`, {
            method: 'POST',
            body: JSON.stringify(taskgroup)
        }).then(res => {
            return Promise.resolve(res);
        });
    }

    // Delete Work task group by id
    public static async deleteById(id: number | undefined) {
        const res = await apiFetch(`${WorkTaskGroupService.APIUrl}/api/worktaskgroups/${id}`, {
            method: 'DELETE'
        });
        return Promise.resolve(res);
    }


}